exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".long-press-button.long-press-button--holding {\n  position: relative;\n}\n.long-press-button.long-press-button--holding.fill:after {\n  content: '';\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  animation-name: fill;\n  animation-delay: inherit;\n  animation-duration: inherit;\n  animation-fill-mode: forwards;\n  animation-timing-function: linear;\n  border-radius: inherit;\n  background: linear-gradient(180deg, rgba(111, 148, 182, 0.3) 100%, transparent 0) no-repeat center bottom;\n  background-size: 100% 0;\n  mix-blend-mode: multiply;\n}\n@keyframes fill {\n  to {\n    background-size: 100% 100%;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/common/Components/LongPressButton/style.less
// module id = 3160
// module chunks = 0